import React, { ReactElement } from "react";

import { ContentListGridSizerProps } from "../layout/editor/content-list-grid-sizer";

import {
  BackgroundList,
  BackgroundListProps,
  BackgroundListRef,
} from "./background-list";
import { GenerateAIBackground } from "./generate-ai-background";

export type BackgroundsPanelProps = Pick<
  BackgroundListProps,
  "selectedBackgroundId" | "selectedBackgroundIdChange" | "query" | "filters"
> &
  Pick<ContentListGridSizerProps, "gridSize"> & {
    backgroundListRef: React.RefObject<BackgroundListRef>;
    showAiBackground: boolean;
    onCloseAiBackground: () => void;
  };

export default function BackgroundsPanel({
  selectedBackgroundId,
  selectedBackgroundIdChange,
  query,
  filters,
  gridSize,
  backgroundListRef,
  showAiBackground,
  onCloseAiBackground,
}: BackgroundsPanelProps): ReactElement {
  if (showAiBackground) {
    return (
      <GenerateAIBackground
        onBackgroundIdChange={selectedBackgroundIdChange}
        onClose={onCloseAiBackground}
      />
    );
  }

  return (
    <div className="flex h-full min-h-0 flex-col">
      <BackgroundList
        ref={backgroundListRef}
        query={query}
        filters={filters}
        gridSize={gridSize}
        selectedBackgroundId={selectedBackgroundId}
        selectedBackgroundIdChange={selectedBackgroundIdChange}
      />
    </div>
  );
}
